import { Component, Input, Output, EventEmitter } from '@angular/core';
import {STATO_ENUM_OPTIONS} from "../../../_helpers/StatoEnumOptions";
import {StatoEnum} from "../../../_models/generated/stato-enum";

@Component({
    selector: 'app-select-stati-ordini',
    templateUrl: './select-stati-ordini.component.html',
    styleUrls: ['./select-stati-ordini.component.scss'],
    standalone: false
})
export class SelectStatiOrdiniComponent {
  @Input() stato: StatoEnum = StatoEnum.NON_DISPONIBILE;
  @Output() statoChange = new EventEmitter<StatoEnum>();
  stati = STATO_ENUM_OPTIONS;
  
  selectStato() {
    this.statoChange.emit(this.stato);
  }

  cancelStato() {
    this.statoChange.emit(-1);
  }
}
